import styled from '@emotion/styled';

import Table from '../../ComponentLibrary/oc-table';

export const Container = styled.div`
  display: flex;
  gap: 36px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const FormColumn = styled.div`
  flex: 1;
  padding: 24px;
  background: #e6e6e6;
  max-width: 33%;
  max-height: fit-content;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const ColumnTitle = styled.p`
  font-weight: bold;
  font-size: 24px;
  line-height: 24px;
  padding-bottom: 8px;
  border-bottom: 2px solid #585858;
  margin: 0;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;
`;

export const FormButtons = styled.div`
  display: flex;
  gap: 16px;

  a {
    min-width: fit-content;
  }
`;

export const ResultsContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 66%;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const ResultsColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-bottom: 16px;
`;

export const ResultsTitle = styled.p`
  font-weight: bold;
  font-size: 28px;
  line-height: 28px;
  margin: 0;
`;

export const QuietZoneTable = styled(Table)`
  margin-top: 16px;

  @media (max-width: 1200px) {
    table-layout: fixed;
  }

  th {
    text-transform: capitalize;
    text-align: left;

    sup {
      font-size: 10px;
    }
  }

  thead {
    th:nth-child(3) {
      text-align: center;
    }
  }

  tbody {
    tr:nth-child(odd) {
      background: #f8f8f8;
    }

    td {
      height: 1px;
      font-size: 24px;
      line-height: 26px;
      font-weight: 600;

      @media (max-width: 768px) {
        font-size: 20px;
        line-height: 26px;
      }
    }
  }
`;

export const UpTo = styled.p`
  margin: 0;
  font-weight: 400 !important;
  font-size: 14px;
  line-height: 18px;
`;

export const ResultsLeftHeader = styled.p`
  font-family: 'OCRoboto', sans-serif;
  font-weight: bold;
  font-size: 20px;
  line-height: 18px;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 18px;
  }
`;

export const ResultsLeftSubHeader = styled.p`
  font-family: 'OCRoboto', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  color: #333333;
  margin: 0;
  margin-top: 4px;
  text-wrap: nowrap;

  @media (max-width: 1200px) {
    text-wrap: wrap;
  }
`;

export const Or = styled.p`
  text-transform: uppercase;
  font-weight: bold;
  font-size: 20px;
  line-height: 18px;
  color: #d40f7d;
  margin: 12px 0;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 18px;
  }
`;

export const TwoRowsColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const SavingsContainer = styled.div`
  font-weight: bold;
  font-size: 20px;
  line-height: 20px;
  padding: 0 12px;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 16px;
  }
`;

export const SavingsNumbers = styled.div`
  display: flex;
  justify-content: space-between;
  text-align: left;
  max-width: 28em;
  margin-top: 24px;

  div {
    p:first-child {
      margin: 0;
      font-family: 'Oswald', sans-serif;
      font-weight: 600;
      font-size: 40px;
      line-height: 42px;
      text-transform: uppercase;

      @media (max-width: 768px) {
        font-size: 32px;
        line-height: 34px;
      }
    }

    p {
      margin-bottom: 0;
      margin-top: 8px;
    }
  }
`;

export const TextPink = styled.span`
  color: #d40f7d;
`;

export const EnvironmentContainer = styled.div`
  border-top: 1px solid #000000;
  margin-top: 32px;
  padding: 32px 12px;

  @media (max-width: 768px) {
    padding: 32px 0px;
  }
`;

export const EnvironmentTitle = styled.p`
  font-weight: bold;
  font-size: 24px;
  line-height: 24px;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 22px;
    line-height: 22px;
  }
`;

export const EnvironmentSubtitle = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  margin: 0;
  margin-top: 0px;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 18px;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const EnvironmentCard = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-around;
  padding: 26px 16px;
  border: 1px solid #000000;
  text-align: center;
  height: 331px;

  @media (max-width: 768px) {
    min-height: 282px;
  }

  p {
    margin: 0;
    font-weight: bold;
    font-size: 16px;
    line-height: 18px;
    margin-bottom: 8px;
  }

  div:first-child {
    p:nth-child(1) {
      span {
        display: block;
        font-size: 14px;
        line-height: 18px;
        font-weight: 400;
        margin-top: 4px;
      }
    }

    p:nth-child(2) {
      font-family: 'Oswald', sans-serif;
      font-weight: 600;
      font-size: 40px;
      line-height: 42px;

      @media (max-width: 768px) {
        font-size: 32px;
        line-height: 34px;
      }
    }

    p:nth-child(3) {
      font-weight: 400;

      @media (max-width: 768px) {
        font-size: 14px;
        line-height: 18px;
      }
    }
  }

  div + div {
    p:nth-child(2) {
      font-weight: 400;
      font-size: 12px;
      line-height: 12px;
      margin-bottom: 0px;
      margin-top: 6px;
    }

    p:nth-child(3) {
      font-weight: 400;
      margin-top: 0;

      span {
        font-weight: bold;
        font-size: 20px;
        line-height: 18px;

        @media (max-width: 768px) {
          font-size: 16px;
          line-height: 18px;
        }
      }
    }
  }
`;

export const InputWarning = styled.p`
  font-size: 12px;
  line-height: 12px;
  margin-top: 8px;
  margin-bottom: 0;
  color: #585858;
`;
